var map = {
	"./drink.gif": 5570,
	"./drink.png": 7909,
	"./flavor.gif": 5996,
	"./flavor.png": 2575,
	"./ice.gif": 4917,
	"./ice.png": 1526,
	"./location.gif": 1933,
	"./location.png": 702,
	"./sweet.gif": 5220,
	"./sweet.png": 6615,
	"./time.gif": 279,
	"./time.png": 2376,
	"./topping.gif": 4261,
	"./topping.png": 3254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5185;